export const colors = {
  primary: "#3e41a5",
  purpleGrey: "#616992",
  lightGrey: "#f6f5f5",
  grey: "#e9ecef",
  cherry: "#D2042D",
  orange: "#FA5F55",
  lightOrange: "#ffc36d61",
  yellow: "#ff8f00",
  pastelPurple: "#966fd6",
  lavender: "#e6e6fa",
  blue: "#0190cd",
  white: "#ffffff",
};
